import { render } from "./CreateBackupSchedule.vue?vue&type=template&id=0da24f13&scoped=true"
import script from "./CreateBackupSchedule.vue?vue&type=script&lang=js"
export * from "./CreateBackupSchedule.vue?vue&type=script&lang=js"

import "./CreateBackupSchedule.vue?vue&type=style&index=0&id=0da24f13&lang=less&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da24f13"]])

export default __exports__